<style scoped>
  .page {
    padding: 8px;
    margin-top: -48px;
  }
</style>>
<template>
  <div class="page">
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from "qs"
  import { maidian } from '../maidian.js'
  import {
    setOptions, bootstrap
  } from 'vue-gtag'
  export default {
    name: 'spreadTrack',
    metaInfo() {
      let cid = this.$route.query.cid;
      return maidian(cid)
    },
    mounted() {
      this.enablePlugin()
      // eslint-disable-next-line no-undef
      if (window.gtagPageView) {
        // eslint-disable-next-line no-undef
        window.gtagPageView()
      }
      let cid = this.$route.query.cid;
      if (cid) {
        let params = {
          imei: 'h5',
          channel: cid,
          ch: 'h5',
          language: 'test'
        }
        let baseApi = process.env.NODE_ENV === 'production' ? 'https://www.liferesting.com' : '';
        // eslint-disable-next-line no-console
        console.log(baseApi)
        //http://127.0.0.1:8088   https://interface.liferesting.com
        axios.post(baseApi + '/api/H5Record/interface', qs.stringify(params)).then(response => {
          let data = response.data;
          if (data.result === '0') {
            window.location.href = 'https://apps.apple.com/us/app/life-fun-funny-test-on-life/id1513875953'
          }
        })
      } else {
        window.location.href = 'https://apps.apple.com/us/app/life-fun-funny-test-on-life/id1513875953'
      }
    },
    methods: {
      enablePlugin() {
        setOptions({
          config: {
            id: 'UA-173073542-2' 
          }
        })
        bootstrap().then(() => {
          // all done!
        })
      }
    }
  }
</script>